module.exports = "precision mediump float;\nvarying vec2 texCoord;\nvarying vec4 color;\n\n#ifdef VERT\n\nattribute vec2 p;\nattribute vec2 st;\nattribute vec4 c;\nuniform mat4 proj;\n\nvoid main()\n{\n\ttexCoord = st;\n\tcolor = c;\n\tgl_Position = proj*vec4(p, 0.0, 1.0);\n}\n\n#else\n\nuniform sampler2D tex;\n\nvoid main()\n{\n\tgl_FragColor = texture2D(tex, texCoord)*color;\n}\n\n#endif\n"


//////////////////
// WEBPACK FOOTER
// ./client/shaders/sprite.glsl
// module id = 14
// module chunks = 0